import { createSelector } from 'reselect';

// Base selector - return only the feed slice not the whole state object
export const selectFeedState = state => state.feed || {};

// Memoized derived selectors
export const selectFeedInitialized = createSelector(
  [selectFeedState],
  feedState => feedState.feedInitialized || false
);

export const selectIsFeedLive = createSelector(
  [selectFeedState],
  feedState => feedState.isFeedLive || false
);

export const selectRequests = createSelector(
  [selectFeedState],
  feedState => feedState.requests || []
);

export const selectTotalRequests = createSelector(
  [selectFeedState],
  feedState => feedState.totalRequests || 0
);

export const selectUnits = createSelector(
  [selectFeedState],
  feedState => feedState.units || []
);

export const selectFilterOptions = createSelector(
  [selectFeedState],
  feedState => feedState.filterOptions || {}
);

export const selectFilterSelections = createSelector(
  [selectFeedState],
  feedState => feedState.filterSelections || {}
);

export const selectFilterSearchText = createSelector(
  [selectFeedState],
  feedState => feedState.filterSearchText || ''
);

export const selectRefreshFullFeed = createSelector(
  [selectFeedState],
  feedState => feedState.refreshFullFeed || false
);

export const selectExportCSVRequests = createSelector(
  [selectFeedState],
  feedState => feedState.exportCSVRequests || []
);

export const selectPrintRequests = createSelector(
  [selectFeedState],
  feedState => feedState.printRequests || []
);


// More complex selectors that need memoization
export const selectActiveRequests = createSelector(
  [selectRequests],
  (requests) => requests.filter(req => req.Status !== 'finished')
);

export const selectCompletedRequests = createSelector(
  [selectRequests],
  (requests) => requests.filter(req => req.Status === 'finished')
);